import { OrderDetail } from '@cart-ui/OrderDetail/OrderDetail'
import { type CountryCode } from '@constants'
import { type DiscountItem } from '@hooks-api/types/dataModel/coupon'
import { type MobileMediaQuery } from '@pets-ui/tokens/breakpoints.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'

const MOBILE: MobileMediaQuery = '@media (max-width: 480px)'

const styles = stylex.create({
  isMobile: {
    marginTop: {
      [MOBILE]: 20,
      default: 0,
    },
  },
})

interface PaymentDetailsUIProps {
  discountItems?: DiscountItem[]
  shippingTotal?: number
  total?: number
  subtotal?: number
  subtotalAfterDiscount?: number
  tax?: number
  countryCode: CountryCode
  addonV2Total?: number
  currency: string
  addonV2TotalBeforeDiscount?: number
}

export function PaymentDetailsUI(props: PaymentDetailsUIProps) {
  const { discountItems = [], shippingTotal, total = 0, subtotal = 0, subtotalAfterDiscount = 0, tax = 0, currency, countryCode, addonV2Total, addonV2TotalBeforeDiscount = 0 } = props

  return (
    <VStack gap={2} rootStyle={styles.isMobile}>
      <OrderDetail
        discountItems={discountItems || []}
        shippingTotal={shippingTotal ?? 0}
        total={total ?? 0}
        subtotal={subtotal ?? 0}
        subtotalAfterDiscount={subtotalAfterDiscount ?? 0}
        tax={tax ?? 0}
        countryCode={countryCode}
        addonV2Total={addonV2Total ?? 0}
        currency={currency || '(幣別未知)'}
        addonV2TotalBeforeDiscount={addonV2TotalBeforeDiscount ?? 0}
      />
    </VStack>
  )
}
